import { Form, message, Modal, notification } from "antd";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { IPlanoGovernoAnexo, IPlanoGovernoAnexoCreate, IPlanoGovernoAnexoForm, IPlanoGovernoAnexoUpdate, IPlanoGovernoEixo, IPlanoGovernoEixoCreate, IPlanoGovernoEixoForm } from "../../interfaces";
import toast from "../../../../utils/toast";
import PlanoGovernoService from "../../../../services/http/services/PlanoGovernoService";
import { EmitError } from "../../../../utils/EmitError";

interface IParamsAnexo {
    handleSave: () => void,
    isModalOpen: boolean,
    isEditarAnexo: boolean,
    anexoSelected: IPlanoGovernoAnexo | undefined
}

export default function useAnexo({ handleSave, isModalOpen, isEditarAnexo, anexoSelected }: IParamsAnexo) {

    const [urlPdfAnexo, setUrlPdfAnexo] = useState<string | undefined>('');
    const [formAnexo] = Form.useForm();
    const refFormAnexo = useRef<any>(null);
    const [modalArquivoOpen, setIsModalArquivoOpen] = useState<boolean>(false);
    const [arquivoModal, setArquivoModal] = useState<string>();
    const [fileList, setFileList] = useState<any>([]);
    const [anexo, setAnexo] = useState<IPlanoGovernoAnexo>();
    const [isLoadingForm, setIsLoadingForm] = useState<boolean>(false);
    const controller = new AbortController();
    const [citySelected, setCitySelected] = useState<string>();

    const onClickBotaoSalvarAnexo = useCallback((): void => {


        const handleCreateAnexo = async (anexo: IPlanoGovernoAnexoCreate) => {
            try {
                setIsLoadingForm(true);

                const formData = new FormData();
                formData.append('idibge', anexo.idibge);
                formData.append('nome', anexo.nome);
                formData.append('arquivo', anexo.arquivo);

                const createdAnexo = await PlanoGovernoService.createAnexo(formData).then((value) => {
                    if (value) {
                        toast({
                            type: 'success',
                            text: 'Anexo salvo com sucesso!',
                            duration: 5000,
                        });
                        setAnexo(value);
                        formAnexo.setFieldsValue({ ...value });
                        setIsLoadingForm(false);
                        setFileList([]);

                    }
                });
                handleSave();

                setIsLoadingForm(false);
            } catch (err: any) {
                EmitError(err, true);
                setIsLoadingForm(false);
                handleSave();
            }
        }


        const handleUpdateAnexo = async (uuid: string, anexo: IPlanoGovernoAnexoUpdate) => {
            try {
                setIsLoadingForm(true);

                const formData = new FormData();
                formData.append('nome', anexo.nome);
                formData.append('arquivo', anexo.arquivo);

                const updatedAnexo = await PlanoGovernoService.updateAnexo(uuid, formData).then((value) => {
                    if (value) {
                        toast({
                            type: 'success',
                            text: 'Anexo atualizado com sucesso!',
                            duration: 5000,
                        });
                        setAnexo(value);
                        formAnexo.setFieldsValue({ ...value });
                        setIsLoadingForm(false);
                        setFileList([]);

                    }
                });

                handleSave();
                setIsLoadingForm(false);
            } catch (err: any) {
                EmitError(err, true);
                setIsLoadingForm(false);
                handleSave();
            }
        }


        refFormAnexo.current
            .validateFields()
            .then((values: any) => {
                values.idibge = Number(citySelected);

                if (values.uuid) {
                    const arquivo = values.arquivo[0].originFileObj;
                    if (arquivo) {
                        handleUpdateAnexo(values.uuid, { ...values, arquivo });
                        return;
                    }
                    handleUpdateAnexo(values.uuid, values)
                    return;
                }

                const arquivo = values.arquivo[0].originFileObj;
                if (!arquivo) {
                    notification.error({
                        message: "Erro",
                        description: "Arquivo é obrigatório!",
                    });
                    return;
                }

                handleCreateAnexo({ ...values, arquivo });
            })
            .catch((errorInfo: any) => {
                notification.error({
                    message: "Erro",
                    description: "Preencha os campos obrigatórios!",
                });
            });
    }, [citySelected]);



    const handleChangeAnexos = (info: any) => {
        let newFileList = [...info.fileList];

        newFileList = newFileList.map((file) => {
            const isPdf = file.type.includes("pdf");
            const isLt10M = file.size / 1024 / 1024 < 10;


            if (file.type) {
                if (!isPdf) {
                    message.error("Somente arquivos PDFs são suportados.");
                    return false;
                }

                if (!isLt10M) {
                    message.error("O PDF deve ser menor que 10MB.");
                    return false;
                }
                return file;
            }
            return file;
        });

        //remove os arquivos inválidos da lista
        newFileList = newFileList.filter((file) => {
            if (file !== false) {
                return file;
            }
        });

        formAnexo.setFieldsValue({
            arquivo: newFileList,
        });

        setFileList(newFileList);
    };


    const removerArquivoAnexo = (file: any, index: number) => {
        Modal.confirm({
            title: "Remover arquivo",
            content:
                "Deseja realmente remover o arquivo? (Essa ação não pode ser desfeita)",
            okText: "Sim",
            cancelText: "Não",
            onOk() {
                setFileList([]);
                if (!file?.uid) {

                }
            },
            onCancel() { },
        });
    };

    const downloadImage = (url: any) => {
        fetch(url)
            .then((response) => response.blob())
            .then((blob) => {
                // Cria um elemento 'a' para iniciar o download
                const element = document.createElement("a");
                element.href = URL.createObjectURL(blob);
                element.download = url.split("/").pop() || "download";
                element.click();
            })
            .catch((error) => {
                window.open(url);
            });
    };

    const savePdfReceived = useCallback(() => {
        if (!urlPdfAnexo) {
            return;
        }
        const element = document.createElement("a");
        element.href = urlPdfAnexo;
        element.download = "download";
        element.target = '_blank';
        element.click();

    }, [urlPdfAnexo]);

    useEffect(() => {
        const controller = new AbortController();

        const fetchUrl = async () => {
            if (anexoSelected) {
                try {
                    setIsLoadingForm(true);
                    const result = await PlanoGovernoService.getUrlAnexoByArquivo(
                        anexoSelected.arquivo,
                        controller.signal
                    );
                    setUrlPdfAnexo(result.arquivo_url || '');
                    setIsLoadingForm(false);
                } catch (error) {
                    console.error('Erro ao buscar URL do anexo:', error);
                    setIsLoadingForm(false);
                    setUrlPdfAnexo(''); // Defina um valor padrão em caso de erro
                }
            } else {
                setUrlPdfAnexo('');
            }
        };

        fetchUrl();

        return () => {
            controller.abort(); // Aborta a requisição se o componente desmontar
        };
    }, [anexoSelected]);

    useEffect(() => {

        let city = localStorage.getItem("@GovfacilGestor:citySelected");

        if (city) {
            setCitySelected(city);
        }
    }, []);


    useMemo(() => {
        if (!isEditarAnexo) {
            formAnexo.resetFields();
            setFileList([]);
        }
    }, [isModalOpen, isEditarAnexo]);

    useMemo(() => {
        formAnexo.setFieldsValue({
            ...anexoSelected,
        });
        setAnexo(anexoSelected);
        setFileList([anexoSelected?.arquivo]);
    }, [anexoSelected])

    return {
        formAnexo,
        refFormAnexo,
        modalArquivoOpen,
        arquivoModal,
        setIsModalArquivoOpen,
        setArquivoModal,
        fileList,
        onClickBotaoSalvarAnexo,
        handleChangeAnexos,
        removerArquivoAnexo,
        downloadImage,
        isLoadingForm,
        urlPdfAnexo,
        savePdfReceived
    };
}
